// flow weak

import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Checkbox,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  InputGroup,
  Glyphicon,
  Image,
  ListGroup,
  ListGroupItem,
  Carousel,
  Alert,
  Table,
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";

import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";

import "../dashboard/dashboard.scss";
import CountryStateCity from "../../../components/countryStateCity/CountryStateCity";
import { voucherStatus } from "../../../redux/actions/frontActions";
import logo from "../../../img/ddb-logo.png";

import { Notification } from "../../../components/notifications";

import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import NumberFormat from "react-number-format";
import Cookies from "universal-cookie";

import moment from "moment";
import ReactHtmlParser from "react-html-parser";
import languageConfig from "../../../config/languageConfig";

const cookies = new Cookies();

const history = createBrowserHistory();
let cart = "";
class Redeem extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props, context) {
    super(props, context);
    this.state = {
      email: "",
      orderID: "",
      showAlert: false,
      disabled: false,
      orderList: "",
      hover: false,
      cancel: false,
      c_date: new Date(),
      //default_lang: 'en',
      //default_lang: (cookies.get('default_lang') ? cookies.get('default_lang') : 'en'),
      multi_lang: "no",
      lang: "",
      default_lang: cookies.get("default_lang")
        ? cookies.get("default_lang")
        : "en",
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.viewVoucherDetails = this.viewVoucherDetails.bind(this);
    this.Clear = this.Clear.bind(this);
  }

  hoverOn = (e) => {
    this.setState({
      hover: true,
      hoverID: e.target.attributes.getNamedItem("data-id").value,
    });
  };

  hoverOff = (e) => {
    this.setState({
      hover: false,
      hoverID: e.target.attributes.getNamedItem("data-id").value,
    });
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });

    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ disabled: false });
  };

  setDefaultLanguage = (lang) => {
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    siteData.default_lang = lang;
    localStorage.setItem("siteDDBStatus", JSON.stringify(siteData));
    this.setState({
      default_lang: lang,
    });

    let d = new Date();
    d.setTime(d.getTime() + 480 * 60 * 1000);
    cookies.set("default_lang", lang, { path: "/", expires: d });

    this.props.setLanguage(lang);
    this.props.getSiteStatus(lang);
    this.props.getMenuList({
      page: 1,
      lang: lang,
      cityID: siteData.default_city,
    });
    if (cookies.get("token")) {
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: lang});
      this.props.getCartDetail({ userKey: cookies.get("token"), lang: lang });
    }
  };

  handlePageChange = (page) => {
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    if (siteData) {
      if (siteData.default_city || siteData.multi_lang == "yes") {
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get("default_lang")
            ? cookies.get("default_lang")
            : siteData.default_lang,
        });
      }
    }

    this.setState({
      currentPage: page,
      cartTotal: 0,
    });
    if (cookies.get("token")) {
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: (siteData && siteData.default_lang) ? siteData.default_lang : this.state.default_lang});
      this.props.getCartDetail({
        userKey: cookies.get("token"),
        lang:
          siteData && siteData.default_lang
            ? siteData.default_lang
            : this.state.default_lang,
      });
    }
  };

  handleDismiss() {
    this.setState({ showAlert: false });
  }

  handleShow() {
    this.setState({ showAlert: true });
  }

  Clear() {
    this.setState({
      voucherNumber: "",
      customerSpendAmt: "",
    });
  }

  componentWillMount() {
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));

    if (siteData) {
      if (siteData.default_city || siteData.multi_lang == "yes") {
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: siteData.default_lang,
        });
      }
    }

    if (this.props.themeData) {
      if (this.props.themeData.button) {
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }
    }

    let voucherIDParams = this.props.route.match.params.voucherID
      ? this.props.route.match.params.voucherID
      : "";
    if (voucherIDParams) {
      this.setState({ voucherNumber: voucherIDParams });
    }
    let QueryString = new URLSearchParams(window.location.search);
    if (QueryString.get("voucherNumber")) {
      this.setState({ voucherNumber: QueryString.get("voucherNumber") });
      this.props.voucherStatus({
        voucherNumber: QueryString.get("voucherNumber"),
        lang: this.state.default_lang,
        redeemedBy: "Merchant",
        email: QueryString.get("email") ? QueryString.get("email") : "",
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.language) {
      if (this.state.default_lang !== nextProps.language) {
        this.setState({ default_lang: nextProps.language });
      }
    }

    if (nextProps.themeData) {
      if (nextProps.themeData.button) {
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }
    }

    if (this.props.orderRedeem != nextProps.orderRedeem) {
      if (nextProps.orderRedeem) {
        this.setState({ disabled: false });
        this.setState({ showAlert: true });
        this.handleShow();
        this.props.renderAlert("success", nextProps.orderRedeem.message);
        window.scrollTo(0, 0);
      }

      if (
        nextProps.orderRedeem &&
        nextProps.orderRedeem.viewBy == "VoucherDetail"
      ) {
        this.setState({
          voucherDetailList: nextProps.orderRedeem.data,
        });
      } else {
        this.setState({
          voucherDetailList: "",
        });
      }
    }

    if (this.props.error != nextProps.error) {
      if (nextProps.error) {
        this.setState({ showAlert: true });
        this.setState({ disabled: false });
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        window.scrollTo(0, 0);
      }
    }

    if (this.props.message !== nextProps.message) {
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType,
      });
      //Clear();
    }
  }

  componentWillUpdate(nextProps, nextState) {}

  validate = () => {
    let isError = false;
    const errors = {};
    if (!this.state.voucherNumber) {
      isError = true;
      this.setState({ voucherNumberError: "red" });
    }
    return isError;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const err = this.validate();

    if (!err) {
      this.setState({ disabled: true });
      this.props.voucherStatus({
        voucherNumber: this.state.voucherNumber,
        lang: this.state.default_lang,
        redeemedBy: "Merchant",
        customerSpendAmt: this.state.customerSpendAmt,
      });
    }
  };

  viewVoucherDetails = (voucherNumber) => {
    this.props.voucherStatus({
      voucherNumber: voucherNumber,
      lang: this.state.default_lang,
      redeemedBy: "Merchant",
      buttonBy: "viewDetail",
    });
    this.setState({ cancel: false });
  };

  handleCancel = (e) => {
    this.setState({ cancel: true, voucherDetailList: "", showAlert: false });
  };

  componentDidMount() {
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    let disableSubscriptionPopup = localStorage.getItem(
      "disableSubscriptionPopup"
    )
      ? localStorage.getItem("disableSubscriptionPopup")
      : false;
    let accessibleCities = localStorage.getItem("accessibleCities")
      ? JSON.parse(localStorage.getItem("accessibleCities"))
      : [];

    // alert("Footer default_lang"+siteData.default_lang);
    // alert("Footer multi_lang"+siteData.multi_lang);
    // alert("Footer lang"+siteData.lang);

    if (siteData) {
      if (siteData.default_city || siteData.multi_lang == "yes") {
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get("default_lang")
            ? cookies.get("default_lang")
            : siteData.default_lang,
        });
      }
    }

    if (siteData) {
      this.setState({ fontFamilies: siteData.font_families });
    }

    if (siteData) {
      this.setState({
        twitterPage: siteData.twitterPage,
        facebookPage: siteData.facebookPage,
        siteName: siteData.siteName,
        youtube_link: siteData.youtube_link,
        insta_link: siteData.insta_link,
      });
      let showCityPasswordFrom = true;
      if (
        siteData.password_protect == "active" &&
        this.props.match.path != "/login" &&
        this.props.match.path != "/register/"
      ) {
        const cityPasswordIndx = siteData.city_passwords.findIndex(
          (x) => x.cityID === siteData.default_city
        );
        const cityIndx = accessibleCities.findIndex(
          (x) => x.cityID === siteData.default_city
        );

        if (
          (cityIndx >= 0 && accessibleCities[cityIndx].status == true) ||
          cityPasswordIndx == -1
        ) {
          showCityPasswordFrom = false;
        }
        this.setState({ showCityPasswordFrom: showCityPasswordFrom });
      }
    }
    // console.log(this.state.c_date);

    if (this.props.themeData) {
      this.setState({
        themeData: this.props.themeData,
      });

      if (this.props.themeData.menu_bar) {
        this.setState({
          menuBgStyles: {
            backgroundColor: this.props.themeData.menu_bar.menu_bar_color,
          },
        });
      } else {
        this.setState({
          menuBgStyles: {
            backgroundColor: "",
          },
        });
      }
      if (this.props.themeData.footer) {
        this.setState({
          footerBgStyles: {
            backgroundColor: this.props.themeData.footer.footer_color,
          },
          footerTextStyles: {
            color: this.props.themeData.footer.footer_text_color,
          },
          footer_social_link_color: {
            color: this.props.themeData.footer.footer_social_link_color,
          },
        });
      } else {
        this.setState({
          footerBgStyles: {
            backgroundColor: "",
          },
          footerTextStyles: {
            color: "",
          },
          footer_social_link_color: {
            color: "",
          },
        });
      }

      if (this.props.themeData.button) {
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      } else {
        this.setState({
          button_color: "",
          mouseover_color: "",
        });
      }
    }
  }

  render() {
    return (
      <div>
        <form onSubmit={this.handleSubmit}>
          <div className="container">
            <Col md={6} mdOffset={3}>
              <div className="panel margin-top">
                <header className="panel-heading text-center text-default">
                  {languageConfig[this.state.default_lang].redeem_voucher1}
                </header>
                <div className="panel-body">
                  {this.state.showAlert && this.state.alertMessage !== "" && (
                    <div className="col-lg-12">
                      <Alert
                        bsStyle={
                          this.state.alertMessage ==
                            "This voucher is expired.  To redeem the  Paid value, select Redeem" ||
                          this.state.alertMessage ==
                            "Ce bon est expiré. Pour échanger la valeur payée, sélectionnez Échanger" ||
                          this.state.alertMessage ==
                            "Here are the voucher details. Scroll down to redeem."
                            ? "warning"
                            : this.state.msgType
                        }
                        onDismiss={this.handleDismiss}
                      >
                        <strong>
                          {this.state.msgType === "warning"
                            ? "Warning"
                            : this.state.alertMessage ==
                                "This voucher is expired.  To redeem the  Paid value, select Redeem" ||
                              this.state.alertMessage ==
                                "Ce bon est expiré. Pour échanger la valeur payée, sélectionnez Échanger" ||
                              this.state.alertMessage ==
                                "Here are the voucher details. Scroll down to redeem."
                            ? " "
                            : " "}{" "}
                        </strong>{" "}
                        {this.state.alertMessage}
                      </Alert>
                    </div>
                  )}
                  <Row>
                    <Col md={12} xs={12}>
                      <strong>
                        {languageConfig[this.state.default_lang].do_not_mark}
                      </strong>
                    </Col>
                    <Col md={12} xs={12}></Col>
                    <Col md={12} xs={12}>
                      <FormGroup>
                        <ControlLabel>
                          {
                            languageConfig[this.state.default_lang]
                              .voucher_number
                          }
                        </ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.voucherNumber}
                          placeholder={
                            languageConfig[this.state.default_lang]
                              .voucher_number
                          }
                          onChange={this.handleChange}
                          style={{ borderColor: this.state.voucherNumber }}
                          name="voucherNumber"
                          autoComplete="off"
                          required
                        />
                      </FormGroup>
                    </Col>
                    <Col md={12} xs={12}>
                      <FormGroup>
                        <ControlLabel>
                          {
                            languageConfig[this.state.default_lang]
                              .customer_spend
                          }{" "}
                          ({languageConfig[this.state.default_lang].optional})
                        </ControlLabel>
                        <FormControl
                          type="number"
                          value={this.state.customerSpendAmt}
                          placeholder={
                            languageConfig[this.state.default_lang]
                              .customer_spend
                          }
                          onChange={this.handleChange}
                          style={{ borderColor: this.state.customerSpendAmt }}
                          name="customerSpendAmt"
                          autoComplete="off"
                          step="0.01"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12} xs={12}>
                      <div>
                        {this.state.voucherDetailList &&
                          this.state.voucherDetailList !== "" &&
                          this.state.cancel == false && (
                            <Table
                              striped
                              bordered
                              condensed
                              hover
                              className="voucherDetails"
                            >
                              <tbody>
                                <tr>
                                  <td xs={3} md={4}>
                                    {
                                      languageConfig[this.state.default_lang]
                                        .offer_name
                                    }
                                  </td>
                                  <td xs={9} md={4}>
                                    {this.state.voucherDetailList.dealText}
                                  </td>
                                </tr>
                                <tr>
                                  <td xs={3} md={4}>
                                    {
                                      languageConfig[this.state.default_lang]
                                        .merchant_name
                                    }
                                  </td>
                                  <td xs={9} md={4}>
                                    {this.state.voucherDetailList.merchantName}
                                  </td>
                                </tr>
                                <tr>
                                  <td xs={3} md={4}>
                                    {
                                      languageConfig[this.state.default_lang]
                                        .voucher_value
                                    }
                                  </td>
                                  <td xs={9} md={4}>
                                    {parseFloat(
                                      this.state.voucherDetailList.voucherValue
                                    ).toFixed(2)}
                                  </td>
                                </tr>
                                <tr>
                                  <td xs={3} md={4}>
                                    {
                                      languageConfig[this.state.default_lang]
                                        .purchase_price
                                    }
                                  </td>
                                  <td xs={9} md={4}>
                                    {this.state.voucherDetailList.purchasePrice}
                                  </td>
                                </tr>
                                <tr>
                                  <td xs={3} md={4}>
                                    {
                                      languageConfig[this.state.default_lang]
                                        .purchase_date
                                    }
                                  </td>
                                  <td xs={9} md={4}>
                                    {this.state.voucherDetailList.purchaseDate
                                      ? moment(
                                          this.state.voucherDetailList
                                            .purchaseDate
                                        ).format("ll")
                                      : ""}
                                  </td>
                                </tr>
                                <tr>
                                  <td xs={3} md={4}>
                                    {
                                      languageConfig[this.state.default_lang]
                                        .expiry_date
                                    }
                                  </td>
                                  <td xs={9} md={4}>
                                    {this.state.voucherDetailList.never_expires ? 'Never Expire' : this.state.voucherDetailList.expiryDate
                                      ? moment(
                                          this.state.voucherDetailList
                                            .expiryDate
                                        ).format("ll")
                                      : ""}
                                  </td>
                                </tr>

                                <tr>
                                  <td xs={3} md={4}>
                                    {
                                      languageConfig[this.state.default_lang]
                                        .fine_print
                                    }
                                  </td>
                                  <td xs={9} md={4}>
                                    {this.state.voucherDetailList
                                      .termsAndConditions
                                      ? ReactHtmlParser(
                                          this.state.voucherDetailList
                                            .termsAndConditions
                                        )
                                      : "-"}
                                  </td>
                                </tr>
                                <tr>
                                  <td xs={3} md={4}>
                                    {
                                      languageConfig[this.state.default_lang]
                                        .voucher_status
                                    }
                                  </td>
                                  <td xs={9} md={4}>
                                    {this.state.voucherDetailList.status ==
                                    "Active"
                                      ? languageConfig[this.state.default_lang]
                                          .active
                                      : this.state.voucherDetailList
                                          .status}{" "}
                                    {this.state.voucherDetailList.status ==
                                    "Redeemed"
                                      ? " At " +
                                        moment(
                                          this.state.voucherDetailList
                                            .redeemed_at
                                        ).format("lll")
                                      : ""}
                                  </td>
                                </tr>
                                <tr>
                                  <td xs={3} md={4}>
                                    {
                                      languageConfig[this.state.default_lang]
                                        .customer_spend
                                    }
                                  </td>
                                  <td xs={9} md={4}>
                                    {this.state.voucherDetailList
                                      .customerSpendAmt
                                      ? ReactHtmlParser(
                                          this.state.voucherDetailList
                                            .customerSpendAmt
                                        )
                                      : "-"}
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          )}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12} xs={12}>
                      {this.state.voucherDetailList &&
                      this.state.voucherDetailList !== "" ? (
                        <Button
                          bsStyle="success"
                          style={{
                            backgroundColor:
                              this.state.hover && this.state.hoverID == "order"
                                ? this.state.mouseover_color
                                : this.state.button_color
                                ? this.state.button_color
                                : "#77C84E",
                          }}
                          data-id={"order"}
                          onMouseEnter={this.hoverOn}
                          onMouseLeave={this.hoverOff}
                          type="submit"
                          disabled={this.state.disabled}
                        >
                          {languageConfig[this.state.default_lang].redeem}
                        </Button>
                      ) : (
                        ""
                      )}
                      {this.state.voucherDetailList &&
                      this.state.voucherDetailList !== "" ? (
                        <Button
                          bsStyle="danger"
                          onClick={this.handleCancel.bind(this)}
                        >
                          {languageConfig[this.state.default_lang].cancel}
                        </Button>
                      ) : (
                        <Button
                          bsStyle="success"
                          style={{
                            backgroundColor:
                              this.state.hover &&
                              this.state.hoverID == "viewDetail"
                                ? this.state.mouseover_color
                                : this.state.button_color
                                ? this.state.button_color
                                : "#77C84E",
                          }}
                          data-id={"viewDetail"}
                          onMouseEnter={this.hoverOn}
                          onMouseLeave={this.hoverOff}
                          onClick={this.viewVoucherDetails.bind(
                            this,
                            this.state.voucherNumber
                          )}
                        >
                          {languageConfig[this.state.default_lang].view_details}
                        </Button>
                      )}
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </div>
        </form>
      </div>
    );
  }
}

Redeem.propTypes = {
  voucherStatus: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  error: state.frontReducer.error,
  orderRedeem: state.frontReducer.ordertracking,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
});

export default compose(
  connect(mapStateToProps, { voucherStatus, renderAlert, clearAlert })
)(Redeem);



// WEBPACK FOOTER //
// ./src/app/views/frontend/user/Redeem.js